import type { I18nLocale } from "@/modules/i18n/types"
import type { BreadcrumbProps as SparkBreadcrumbProps } from "@jobteaser/spark/components/Breadcrumb/Breadcrumb"
import type { FunctionComponent } from "react"

import { Breadcrumb as SparkBreadcrumb } from "@jobteaser/spark/components/Breadcrumb"

import { PREFILTERED_BASENAME } from "@/modules/jobSearchPrefiltered/constants"
import { firstLetterToUpperCase } from "@/modules/jobSearchPrefiltered/utils/firstLetterToUpperCase"

import styles from "./Breadcrumb.module.css"

type BreadcrumbProps = {
  homePageLabel: string
  parentPageLabel: string
  currentSlugPageLabel: string
  locale: I18nLocale
  baseUrl: string
}

export const Breadcrumb: FunctionComponent<BreadcrumbProps> = ({
  homePageLabel,
  parentPageLabel,
  currentSlugPageLabel,
  locale,
  baseUrl,
}) => {
  const breadcrumbs: SparkBreadcrumbProps["items"] = [
    { href: `/${locale}`, text: homePageLabel },
    {
      href: `/${locale}/${PREFILTERED_BASENAME}/list`,
      text: parentPageLabel,
    },
    // We cannot use the ::first-letter CSS selector because there is a pseudo element used in the
    // component so we do it directly in the text.
    firstLetterToUpperCase(currentSlugPageLabel),
  ]

  return (
    <div className={styles.container}>
      <SparkBreadcrumb
        items={breadcrumbs}
        className={styles.breadcrumbTrail}
        data-testid="PrefilteredJobSearch-Breadcrumb"
        schemaBaseUrl={baseUrl}
      />
    </div>
  )
}
